module.exports = __webpack_public_path__ + "static/media/gryphon-house-transform-1.50e7d064.jpeg";